// Cache dữ liệu từ server trong localStorage (để hiện nhanh khi mở trang).
// QUY TẮC: trang hiện cache rồi LUÔN tải bản mới từ server (không bao giờ "tin" cache hết hạn
// mà bỏ qua server); mọi thao tác tạo/lưu/sửa/xoá phải gọi clear*Cache tương ứng.
const KEYS = {
  myRecipes: 'aidicho_my_recipes_cache',
  savedMenus: 'aidicho_saved_menus_cache',
  prices: 'aidicho_prices_cache',
  recipes: 'aidicho_recipes_cache',
};

// Các cache theo từng tài khoản (key có đuôi _<email>)
const PER_USER = ['myRecipes', 'savedMenus', 'prices'];

const keyFor = (name, scope) => (scope ? `${KEYS[name]}_${scope}` : KEYS[name]);

const read = (name, scope) => {
  try {
    const raw = localStorage.getItem(keyFor(name, scope));
    if (!raw) return null;
    const { timestamp, data } = JSON.parse(raw);
    return { data, timestamp };
  } catch (e) {
    return null;
  }
};

const write = (name, scope, data) => {
  try {
    localStorage.setItem(keyFor(name, scope), JSON.stringify({ timestamp: Date.now(), data }));
  } catch (e) {
    // localStorage có thể bị chặn (chế độ ẩn danh, đầy bộ nhớ...): bỏ qua, app vẫn chạy
  }
};

const clear = (name, scope) => {
  try {
    localStorage.removeItem(keyFor(name, scope));
  } catch (e) {
    // bỏ qua
  }
};

// ---- Món của tôi ----
export const getCachedMyRecipes = (email) => read('myRecipes', email);
export const saveMyRecipesCache = (email, data) => write('myRecipes', email, data);
export const clearMyRecipesCache = (email) => clear('myRecipes', email);

// ---- Thực đơn đã lưu ----
export const getCachedSavedMenus = (email) => read('savedMenus', email);
export const saveSavedMenusCache = (email, data) => write('savedMenus', email, data);
export const clearSavedMenusCache = (email) => clear('savedMenus', email);

// ---- Giá của người dùng ----
export const getCachedPrices = (email) => read('prices', email);
export const savePricesCache = (email, data) => write('prices', email, data);
export const clearPricesCache = (email) => clear('prices', email);

// ---- Danh sách món mẫu công khai (chung cho mọi tài khoản) ----
export const clearRecipesCache = () => clear('recipes', null);

// Xoá cache dữ liệu riêng của một tài khoản (đăng xuất / đổi tài khoản)
export const clearUserDataCaches = (email) => {
  if (!email) return;
  PER_USER.forEach((name) => clear(name, email));
};
